export class FeatureDto {
  id: string;
  name: string;
  displayName: string;
  enabled: boolean;
  enabledPerDistrict: boolean;
  enabledPerStaff: boolean;
}
